import './styles.css';

import { Container, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NumberFormat from 'react-number-format';
import InputMask from 'react-input-mask';
import Scanner from './components/Scanner/index';
import ConfirmationModal from './components/ConfirmationModal/index';
import MultiSelect from '../../shared/MultiSelect';
import api from '../../../services/API';
import { atualizarSaldo } from '../../../store/modules/parceiro/actions';
import { format } from 'date-fns';
import { isMobile } from 'react-device-detect';
import { toast } from 'react-toastify';
import { formatCurrency } from '../../../utils/formatNumber';
import { atualizarTipoPontuacao } from '../../../store/modules/parceiro/actions';


export default function UploadFoto() {
  const dispatch = useDispatch();
  const parceiroRedux = useSelector((state) => {
    return state.parceiro;
  });

  function formatoMoeda(value) {
    if (!Number(value)) return '';
    const quantia = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value / 100);
    return `${quantia}`;
  }

  const [enviando, setEnviando] = useState(true);
  const [codigo, setCodigo] = useState();
  const [saldo, setSaldo] = useState();
  const [total, setTotal] = useState(0);
  const [totalVenda, setTotalVenda] = useState(0);
  const [erroInput, setErroInput] = useState({
    erroDados: false,
    erroTotal: false,
    erroProdutoInvalido: false,
    erroSaldo: false,
  });
  const [auxiliarSaldo, setAuxiliarSaldo] = useState([]);

  const [itens, setItens] = useState([]);
  const [cpf, setCpf] = useState('');
  const [parceiro, setParceiro] = useState('');
  const [codRevenda, setCodRevenda] = useState('');
  const [tipoFiscal, setTipoFiscal] = useState('');
  const [identificador, setIdentificador] = useState('');
  const [realizadoEm, setRealizadoEm] = useState('');
  const [nome, setNome] = useState('');
  const [valorUnitario, setValorUnitario] = useState('');
  const [auxiliarValorUnitario, setAuxiliarValorUnitario] = useState('');
  const [qtde, setQtde] = useState(1);
  const [valorDescontoItem, setValorDescontoItem] = useState(null);
  const [subTotalItem, setSubTotalItem] = useState(null);
  const [descontos, setDescontos] = useState(null);
  const [nomeArquivo, setNomeArquivo] = useState(null);
  const [enviarMensagem, setEnviarMensagem] = useState(false);

  const [cameraIsOpen, setCameraIsOpen] = useState(false);
  const [results, setResults] = useState([]);
  
  const [produtos, setProdutos] = useState([]);
  const [produtoSelecionado, setProdutoSelecionado] = useState('');
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  const [buscaProduto, setBuscaProduto] = useState('');
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [produtosFiltrados, setProdutosFiltrados] = useState([]);
  const [carregandoProdutos, setCarregandoProdutos] = useState(false);

  const [valorUnitarioTipo3, setValorUnitarioTipo3] = useState('');
  const [quantidadeTipo3, setQuantidadeTipo3] = useState('1');
  const [valorTotalTipo3, setValorTotalTipo3] = useState('0');
  const [itensTipo3, setItensTipo3] = useState([]);
  const [subTotalItemTipo3, setSubTotalItemTipo3] = useState('');
  const [totalTipo3, setTotalTipo3] = useState(0);
  const [configuracoes, setConfiguracoes] = useState({
    limiteValorPontuacaoCliente: 0,
    limiteQuantidadePontuacaoCliente: 0
  });
  const [showModalValor, setShowModalValor] = useState(false);
  const [showModalQuantidade, setShowModalQuantidade] = useState(false);
  const [modalData, setModalData] = useState({});

  useEffect(() => {
    setCpf(parceiroRedux.cpf);
    dispatch(atualizarSaldo(parceiroRedux.cpf));
    carregarConfiguracoes();
    buscarTipoPontuacaoAtual();
  }, [parceiroRedux.cpf]);

  const buscarTipoPontuacaoAtual = async () => {
    try {
      const response = await api.get(`/api/revendas?cnpj=${parceiroRedux.cnpjRevenda}`);
      if (response.data && response.data.revendas && response.data.revendas.length > 0) {
        const tipoAtual = response.data.revendas[0].tipoPontuacao;
        if (tipoAtual !== parceiroRedux.tipoPontuacaoRevenda) {
          dispatch(atualizarTipoPontuacao(tipoAtual));
        }
      }
    } catch (error) {
      console.error('Erro ao buscar tipo de pontuação:', error);
    }
  };

  useEffect(() => {
    if (!enviando) {
      enviarVenda();
    }
  }, [enviando]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (mostrarDropdown && buscaProduto && buscaProduto.length >= 2) {
        buscarProdutos(buscaProduto);
      } else if (mostrarDropdown && (!buscaProduto || buscaProduto.length < 2)) {
        carregarProdutosIniciais();
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [buscaProduto, mostrarDropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const produtoInput = document.getElementById('produto');
      const dropdown = document.querySelector('[data-dropdown="produtos"]');
      if (produtoInput && !produtoInput.contains(event.target) && 
          dropdown && !dropdown.contains(event.target)) {
        setMostrarDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (itens && itens.length > 0) {
      let totalPontos = 0;
      let totalEmVendas = 0;
      
      itens.forEach(item => {
        totalPontos += parseInt(item.valorPontos) || 0;
        totalEmVendas += parseFloat(item.valorUnitario) || 0;
      });
      
      setTotal(totalPontos);
      setTotalVenda(totalEmVendas);
    } else {
      setTotal(0);
      setTotalVenda(0);
    }
  }, [itens]);

  const calcularAuxiliarSaldo = (codigo, saldo) => {
    let qtdPorCodigo = 0;

    for (let i = 0; i < itens.length; i++) {
      if (itens[i].codigo === codigo) {
        qtdPorCodigo += 1;
      }
    }

    if (qtdPorCodigo <= saldo) return true;
    return false;
  };

  const pegarForm = (e) => {
    e.preventDefault();

    if (!codigo || !auxiliarValorUnitario)
      return setErroInput((state) => ({
        ...state,
        erroDados: true,
        erroProdutoInvalido: false,
        erroSaldo: false,
      }));
    setErroInput((state) => ({ ...state, erroDados: false }));

    api
      .get(`api/produtos/${codigo}/codigo`)
      .then((prod) => {
        if (prod.data.produtos.length < 1) {
          setErroInput((state) => ({
            ...state,
            erroProdutoInvalido: true,
            erroSaldo: false,
          }));
          return;
        }
        setErroInput((state) => ({ ...state, erroProdutoInvalido: false }));

        api
          .get(`api/historico/codigoUsado/${codigo}/${cpf}`)
          .then((res) => {
            if (res.data === null)
              return setErroInput((state) => ({ ...state, erroSaldo: true }));
            setErroInput((state) => ({ ...state, erroSaldo: false }));
            let qtdProdutoComprados = parseInt(res.data.quantidade);
            let idRevenda = parseInt(res.data.idRevenda);

            api
              .get(`api/vendas_itens/${codigo}/${idRevenda}`)
              .then((itensVendidos) => {
                setErroInput((state) => ({ ...state, erroSaldo: false }));
                setSaldo(qtdProdutoComprados - itensVendidos.data);

                if (itens.length !== 0) {
                  let temSaldoLista = calcularAuxiliarSaldo(
                    codigo,
                    qtdProdutoComprados - itensVendidos.data
                  );
                }

                api
                  .get(`api/produtos/${codigo}/codigo`)
                  .then((produtoBd) => {
                    let produtoConsultado = produtoBd.data.produtos[0];

                    const auxiliarLiberado = (codigo, saldo) => {
                      let qtdPorCodigo = 0;
                      for (let i = 0; i < itens.length; i++) {
                        if (itens[i].codigo === codigo) {
                          qtdPorCodigo += 1;
                        }
                      }

                      let saldoAjuste = saldo;
                      if (saldoAjuste < 0) saldoAjuste = 0;
                      if (saldoAjuste >= 1 && saldoAjuste > qtdPorCodigo)
                        return true;
                      return false;
                    };

                    let produtoDesejado = {
                      ...produtoConsultado,
                      qtde,
                      liberado: auxiliarLiberado(
                        produtoConsultado.codigo,
                        Number(qtdProdutoComprados - itensVendidos.data)
                      ),
                      valorUnitario: auxiliarValorUnitario,
                      valorDesconto: valorDescontoItem,
                      subTotal: auxiliarValorUnitario,
                    };

                    setItens([...itens, produtoDesejado]);
                  })
                  .catch((err) => {
                    setErroInput((state) => ({ ...state, erroSaldo: true }));
                  });
              })
              .catch((err) => {
                setErroInput((state) => ({ ...state, erroSaldo: true }));
              });
          })
          .catch((err) => {
            setErroInput((state) => ({ ...state, erroSaldo: true }));

          });
      })
      .catch((err) => {
        setErroInput((state) => ({ ...state, erroProdutoInvalido: true }));
      });
  };

  const validarDataVenda = (e) => {
    const data = e.replace(/[^\d]/g, '');
    if (!data) return;
    if (data.length < 8) {
      toast.error(`Data inválida`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      setRealizadoEm('');
    }
  };

  const validarCodigo = async (e) => {
    if (!codigo) return;
    if (codRevenda === null || false) {
      toast.error(`Informe o CPF do vendedor Loja primeiro`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
    }
    try {
      const resultado = await api.get(
        `/api/produtos_revenda?codigo=${codigo}&codRevenda=${codRevenda}`
      );
      if (resultado.data.produtosRevenda.length === 0) {
        toast.error(`Produto não encontrado`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        setNome('');
      } else {
        setNome(resultado.data.produtosRevenda[0].nome);
      }
    } catch (err) {
    }
  };

  const delItem = (e) => {
    e.preventDefault();
    const posicao = Number(e.target.id);
    setDescontos(null);
    setTotal(Number(total) - Number(itens[posicao].subTotal));
    setItens(itens.filter((item, index) => index !== posicao));
  };

  const validarCampos = (dados) => {
    const entries = Object.entries(dados);
    let temNulo = false;
    entries.forEach((param) => {
      if (temNulo) return;
      if (param[0] === 'itens' && param[1].length === 0) {
        toast.error(`Adicione itens antes de processar`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        temNulo = true;
        return;
      }
      if (
        param[1] === '' &&
        param[0] !== 'totalVenda' &&
        param[0] !== 'totalDescontos' &&
        param[0] !== 'tipoFiscal' &&
        param[0] !== 'identificador' &&
        param[0] !== 'idFoto'
      ) {
        const elemento = document.getElementsByName(param[0])[0];
        toast.error(`${param[0]} obrigatório`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        temNulo = true;
        return;
      }
    });
    return temNulo;
  };

  const enviarVenda = async (e) => {
    if (total === 0 || !itens) {
      e.preventDefault();
      return setErroInput((state) => ({ erroDados: true, erroTotal: true }));
    }

    if (enviando) return;

    setErroInput((state) => ({ erroDados: false, erroTotal: false }));

    if (!cpf) return;

    const dataAtual = format(new Date(), 'dd/MM/yyyy');
    validarDataVenda(dataAtual);

    const totalItensLiberados = itens.filter((item) => item.liberado);
    let suporteValorUnitario = 0;
    
    totalItensLiberados.forEach((item) => {
      if (item.valorUnitario) suporteValorUnitario += item.valorUnitario;
    });

    const venda = {
      cpf,
      tipoFiscal,
      identificador,
      realizadoEm: dataAtual,
      totalVenda: totalItensLiberados.length > 0 ? suporteValorUnitario : 0,
      totalDescontos: null,
      itens,
      enviarMensagem,
      nomeArquivo,
      tipoPontuacao: parceiroRedux.tipoPontuacaoRevenda
    };

    const temNulo = validarCampos(venda);
    if (temNulo) return;

    try {
      venda.cpf = venda.cpf.replace(/[^\d]/g, '');
      venda.realizadoEm = venda.realizadoEm.replace(/[^\d]/g, '');
      venda.realizadoEm = `${venda.realizadoEm.substring(4)}${venda.realizadoEm.substring(2, 4)}${venda.realizadoEm.substring(0, 2)}`;

      await api.post('/api/pontuacoes/pontuar', {
        venda,
        enviarMensagem,
      });
    } catch (error) {
      toast.error('Erro ao tentar enviar a venda.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      setItens([]);
      setCpf('');
      setParceiro('');
      setTipoFiscal(null);
      setIdentificador(null);
      setRealizadoEm('');
      setCodRevenda('');
      setTotal('');
      setDescontos('');
    }
  };

  const upload = async (e) => {
    e.preventDefault();

    if (!arquivos) {
      toast.error(`Selecione um arquivos primeiro`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }

    let formData = new FormData();

    for (let i = 0; i < arquivos.length; i++) {
      formData.append('arquivos', arquivos[i]);
    }
    formData.append('tipoPontuacao', parceiroRedux.tipoPontuacaoRevenda);
    const resultado = await api.post('/api/upload/venda_foto', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (resultado) {
      toast.success(
        `${Number(resultado.data.total).toLocaleString(
          'pt-BR'
        )} arquivo(s) enviado(s) com sucesso`,
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        }
      );
      setArquivos(null);
      setStatus('Procurar...');
    }
  };

  const [arquivos, setArquivos] = useState(null);
  const [status, setStatus] = useState('Procurar...');

  const insertCode = (code) => setCodigo(code);

  const verificarIdentificador = async (e) => {
    const identificador = e.target.value.replace(/[^\d]/g, '');
    if (!identificador || !tipoFiscal) return;
    if (!parceiroRedux?.cnpjRevenda) {
      toast.error(`Informe o CPF do vendedor Loja primeiro`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }
    
    try {
      const resultado = await api.get(
        `/api/vendas?identificador=${identificador}&tipoFiscal=${tipoFiscal}&cnpjRevenda=${parceiroRedux.cnpjRevenda}`
      );
      if (resultado.data.vendas.length > 0) {
        toast.error(`Venda já processada`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        setIdentificador('');
        setTipoFiscal('');
      }
    } catch (err) {
    }
  };

  const buscarProdutos = async (termo) => {
    if (!termo || termo.length < 2) {
      setProdutosFiltrados([]);
      return;
    }

    setCarregandoProdutos(true);
    try {
      const response = await api.get(`api/produtos_revenda/search`, {
        params: {
          cnpjRevenda: parceiroRedux.cnpjRevenda,
          busca: termo
        }
      });
      setProdutosFiltrados(response.data.produtos || []);
    } catch (error) {
      setProdutosFiltrados([]);
    } finally {
      setCarregandoProdutos(false);
    }
  };

  const carregarProdutosIniciais = async () => {
    setCarregandoProdutos(true);
    try {
      const response = await api.get(`api/produtos_revenda/search`, {
        params: {
          cnpjRevenda: parceiroRedux.cnpjRevenda
        }
      });
      setProdutosFiltrados(response.data.produtos || []);
    } catch (error) {
      setProdutosFiltrados([]);
    } finally {
      setCarregandoProdutos(false);
    }
  };

  const handleProdutosChange = (selectedItems) => {
    const produtosConvertidos = selectedItems.map(item => {
      const produtoOriginal = produtosFiltrados.find(p => p.codigo === item.value);
      return produtoOriginal || { codigo: item.value, codigoNome: item.label };
    });
    setProdutosSelecionados(produtosConvertidos);
  };

  const calcularValorTotalComValor = (valorUnitario) => {
    if (!valorUnitario || valorUnitario === '') {
      setValorTotalTipo3('0');
      return;
    }
    
    let valorLimpo = valorUnitario.replace('R$ ', '').replace(/\./g, '').replace(',', '.');
    const valor = parseFloat(valorLimpo) || 0;
    const qtd = parseFloat(quantidadeTipo3) || 0;
    const total = valor * qtd;
    
    if (isNaN(total) || !isFinite(total)) {
      setValorTotalTipo3('0');
      return;
    }
    
    setValorTotalTipo3(total.toString());
  };

  const calcularValorTotal = () => {
    calcularValorTotalComValor(valorUnitarioTipo3);
  };

  const carregarConfiguracoes = async () => {
    try {
      const response = await api.get('api/configuracoes-gerais');
      setConfiguracoes(response.data);
    } catch (error) {
    }
  };

  const validarValorUnitario = (valor) => {
    if (!valor || valor === '') return true;

    if (showModalQuantidade) {
      setShowModalQuantidade(false);
    }

    let valorLimpo = valor.replace('R$ ', '').replace(/\./g, '').replace(',', '.');
    const valorNumerico = parseFloat(valorLimpo) || 0;
    const limite = parseFloat(configuracoes.limiteValorPontuacaoCliente) || 0;

    if (limite > 0 && valorNumerico > limite) {
      setModalData({
        tipo: 'valor',
        valor: valorNumerico,
        limite: limite
      });
      setShowModalValor(true);
      return false;
    }
    return true;
  };

  const validarQuantidade = (qtd) => {
    if (!qtd || qtd === '') return true;
    
    if (showModalValor) {
      setShowModalValor(false);
    }
    
    const quantidadeNumerica = parseFloat(qtd) || 0;
    const limite = parseInt(configuracoes.limiteQuantidadePontuacaoCliente) || 0;
    
    if (limite > 0 && quantidadeNumerica > limite) {
      setModalData({
        tipo: 'quantidade',
        quantidade: quantidadeNumerica,
        limite: limite,
        produto: produtoSelecionado
      });
      setShowModalQuantidade(true);
      return false;
    }
    return true;
  };

  const confirmarModalValor = () => setShowModalValor(false);

  const cancelarModalValor = () => {
    setShowModalValor(false);
    setValorUnitarioTipo3('');
    setValorTotalTipo3('0');
  };

  const confirmarModalQuantidade = () => setShowModalQuantidade(false);

  const cancelarModalQuantidade = () => setShowModalQuantidade(false);

  const calcularSubTotalItemTipo3 = () => {
    let valorLimpo = valorUnitarioTipo3.replace('R$ ', '').replace(/\./g, '').replace(',', '.');
    const valor = parseFloat(valorLimpo) || 0;
    const qtd = parseFloat(quantidadeTipo3) || 0;
    const subTotal = valor * qtd;
    
    setSubTotalItemTipo3(subTotal.toString());
  };

  const addItemTipo3 = (e) => {
    e.preventDefault();
    
    if (produtosSelecionados.length === 0 || !valorUnitarioTipo3 || !quantidadeTipo3) {
      toast.error(`Informe todos os campos para adicionar um item`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }

    let valorLimpo = valorUnitarioTipo3.replace('R$ ', '').replace(/\./g, '').replace(',', '.');
    const valor = parseFloat(valorLimpo) || 0;
    const qtd = parseFloat(quantidadeTipo3) || 0;

    if (valor < 0 || qtd < 1) {
      toast.error(`Informe somente valores válidos`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }

    const item = {
      codigo: produtosSelecionados[0].codigo,
      nome: produtosSelecionados[0].codigoNome,
      qtde: qtd,
      valorUnitario: valor,
      subTotal: valor * qtd,
    };

    setItensTipo3([...itensTipo3, item]);
    setTotalTipo3(Number(totalTipo3) + Number(item.subTotal));
    
    // Limpar campos
    setProdutosSelecionados([]);
    setValorUnitarioTipo3('');
    setQuantidadeTipo3('1');
    setValorTotalTipo3('0');
    setSubTotalItemTipo3('');
  };

  const delItemTipo3 = (e) => {
    e.preventDefault();
    const posicao = Number(e.target.id);
    setTotalTipo3(Number(totalTipo3) - Number(itensTipo3[posicao].subTotal));
    setItensTipo3(itensTipo3.filter((item, index) => index !== posicao));
  };

  const uploadTipo3 = async (e) => {
    e.preventDefault();

    if (!arquivos) {
      toast.error(`Selecione uma foto primeiro`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }

    if (!tipoFiscal || !identificador || itensTipo3.length === 0) {
      toast.error(`Preencha todos os campos obrigatórios e adicione pelo menos um item`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }

    try {
      let formData = new FormData();
      for (let i = 0; i < arquivos.length; i++) {
        formData.append('arquivos', arquivos[i]);
      }
      formData.append('tipoPontuacao', parceiroRedux.tipoPontuacaoRevenda);

      const uploadResult = await api.post('/api/upload/venda_foto', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!uploadResult || !uploadResult.data) {
        throw new Error('Erro no upload da foto');
      }

      const fotosResponse = await api.get('/api/vendas_fotos/pendentes', {
        params: {
          cpf: parceiroRedux.cpf.replace(/[^\d]/g, '')
        }
      });

      let fotoParaProcessar = null;
      if (fotosResponse.data && fotosResponse.data.fotos && fotosResponse.data.fotos.length > 0) {
        fotoParaProcessar = fotosResponse.data.fotos[0];
      }

      const dataVenda = document.getElementById('dataVenda').value;
      if (!dataVenda) {
        toast.error(`Data da venda é obrigatória`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        return;
      }

      const dataFormatada = dataVenda.replace(/[^\d]/g, '');
      const dataFormatadaFinal = `${dataFormatada.substring(4)}${dataFormatada.substring(2, 4)}${dataFormatada.substring(0, 2)}`;

      const venda = {
        cpf: parceiroRedux.cpf.replace(/[^\d]/g, ''),
        tipoFiscal: tipoFiscal,
        identificador: identificador.replace(/[^\d]/g, ''),
        realizadoEm: dataFormatadaFinal,
        totalVenda: totalTipo3,
        totalDescontos: 0,
        itens: itensTipo3.map((item) => ({
          codigo: item.codigo,
          qtde: item.qtde,
          valorUnitario: item.valorUnitario,
          valorDesconto: 0,
          liberado: true
        })),
        nomeArquivo: fotoParaProcessar ? fotoParaProcessar.diretorioArquivo : null,
        tipoPontuacao: parceiroRedux.tipoPontuacaoRevenda
      };

      const pontuacaoResult = await api.post('/api/pontuacoes/pontuar', {
        venda,
        enviarMensagem,
      });

      if (pontuacaoResult && pontuacaoResult.data) {
        toast.success(pontuacaoResult.data.mensagem, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });

        setArquivos(null);
        setStatus('Procurar...');
        setTipoFiscal('');
        setIdentificador('');
        setItensTipo3([]);
        setTotalTipo3(0);
        setValorUnitarioTipo3('');
        setQuantidadeTipo3('1');
        setValorTotalTipo3('0');
        setSubTotalItemTipo3('');
        document.getElementById('dataVenda').value = '';
      }

    } catch (error) {
      console.error('Erro ao processar venda:', error);
      toast.error('Erro ao processar a venda. Tente novamente.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
    }
  };

  return (
    <Container className="mt-5 mb-5">
      <div>
        <h5>ENVIAR PONTUAÇÃO</h5>
        <hr className="hr-loja mt-0" />
      </div>
      <div className="scannerContent">
        <div className="d-flex flex-column">
          {parceiroRedux?.tipoPontuacaoRevenda === 1 && (
            <form
              id="formUm"
              onSubmit={pegarForm}
              className="form fundo-claro mb-4"
            >
              <div className="contentInput">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0px',
                  }}
                >
                  <label htmlFor="codigoInput" className="align-self-center">
                    Digite o código / referência Morelli
                  </label>
                  <input
                    type="text"
                    name="codigoInput"
                    value={codigo}
                    onChange={(e) => setCodigo(e.target.value)}
                    className="text-center"
                    maxLength="30"
                    style={{ marginBottom: '10px' }}
                  />
                </div>
              </div>
              <label htmlFor="valorVenda" className="align-self-center">
                Digite o valor de venda do produto
              </label>
              <NumberFormat
                className="text-center"
                name="valorVenda"
                allowNegative={false}
                value={auxiliarValorUnitario}
                format={formatoMoeda}
                onValueChange={(values, sourceInfo) => {
                  const { formattedValue, value } = values;
                  setAuxiliarValorUnitario(value);
                }}
              />

              <Row className="d-flex justify-content-center align-items-center mb-2">
                {!enviando ? (
                  <button disabled className="btn-enviar" type="submit">
                    Enviando...
                  </button>
                ) : (
                  <button
                    className="btn-enviar"
                    style={{ height: 'auto' }}
                    type="submit"
                  >
                    Adicionar produto
                  </button>
                )}
              </Row>
            </form>
          )}
          {parceiroRedux?.tipoPontuacaoRevenda === 2 && (
            <form onSubmit={upload} className="form fundo-claro">
              <label htmlFor="arquivos">Foto</label>
              <input
                type="file"
                id="arquivos"
                name="arquivos"
                multiple
                style={{ display: 'none' }}
                onChange={(e) => {
                  setArquivos(e.target.files);
                  e.target.files.length > 0
                    ? setStatus(
                        `${e.target.files.length} arquivos(s) selecionado(s)`
                      )
                    : setStatus('Procurar...');
                }}
              />
              <input
                id="botao"
                type="button"
                value={status}
                onClick={(e) => {
                  document.getElementById('arquivos').click();
                }}
              />
              <Row className="d-flex justify-content-center align-items-center">
                {!enviando ? (
                  <button disabled className="btn-enviar" type="submit">
                    ENVIANDO...
                  </button>
                ) : (
                  <button className="btn-enviar" type="submit">
                    ENVIAR
                  </button>
                )}
              </Row>
            </form>
          )}
          {parceiroRedux?.tipoPontuacaoRevenda === 3 && (
            <form className="form fundo-claro" onSubmit={uploadTipo3}>
              <label htmlFor="arquivos">Foto</label>
              <input
                type="file"
                id="arquivos"
                name="arquivos"
                multiple
                style={{ display: 'none' }}
                onChange={(e) => {
                  setArquivos(e.target.files);
                  e.target.files.length > 0
                    ? setStatus(
                        `${e.target.files.length} arquivos(s) selecionado(s)`
                      )
                    : setStatus('Procurar...');
                }}
                required
              />
              <input
                id="botao"
                type="button"
                value={status}
                onClick={(e) => {
                  document.getElementById('arquivos').click();
                }}
              />
              <div className="row mt-3">
                <div className="col-md-6">
                  <label htmlFor="cpf">CPF</label>
                  <input
                    type="text"
                    id="cpf"
                    name="cpf"
                    className="form-control"
                    placeholder="000.000.000-00"
                    maxLength="14"
                    value={parceiroRedux?.cpf ? parceiroRedux.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : ''}
                    disabled
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="vendedorLoja">Vendedor Loja</label>
                  <input
                    type="text"
                    id="vendedorLoja"
                    name="vendedorLoja"
                    className="form-control"
                    value={parceiroRedux?.nome || ''}
                    disabled
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <label htmlFor="tipoFiscal">Tipo Fiscal</label>
                  <select
                    id="tipoFiscal"
                    name="tipoFiscal"
                    className="form-control"
                    value={tipoFiscal}
                    onChange={(e) => setTipoFiscal(e.target.value)}
                    required
                  >
                    <option disabled value="">
                      Tipo Fiscal
                    </option>
                    <option value="N">Nota fiscal</option>
                    <option value="C">Cupom fiscal</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label htmlFor="numeroFiscal">Nº Fiscal</label>
                  <InputMask
                    id="numeroFiscal"
                    name="numeroFiscal"
                    type="text"
                    placeholder="Nº Fiscal"
                    className="form-control"
                    value={identificador}
                    onChange={(e) => setIdentificador(e.target.value)}
                    onBlur={verificarIdentificador}
                    required
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  <label htmlFor="dataVenda">Data da Venda</label>
                  <InputMask
                    id="dataVenda"
                    name="dataVenda"
                    type="text"
                    placeholder="Data da Venda"
                    className="form-control"
                    mask="99/99/9999"
                    required
                  />
                </div>
              </div>
              
              <label className="mt-4 mb-3 f-18" htmlFor="itens">
                Itens - {`${itensTipo3.length} adicionado(s)`}
              </label>
              
              <div className="row mt-3">
                <div className="col-12">
                  <label htmlFor="produto">Produto</label>
                  <MultiSelect
                    options={produtosFiltrados.map(produto => ({
                      value: produto.codigo,
                      label: produto.codigoNome
                    }))}
                    selectedItems={produtosSelecionados.map(produto => ({
                      value: produto.codigo,
                      label: produto.codigoNome
                    }))}
                    onSelectionChange={handleProdutosChange}
                    placeholder="Selecione um produto..."
                    loading={carregandoProdutos}
                    onFocus={carregarProdutosIniciais}
                    onSearch={buscarProdutos}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <label htmlFor="valorUnitario">Valor Unitário</label>
                  <NumberFormat
                    id="valorUnitario"
                    name="valorUnitario"
                    className="form-control"
                    placeholder="R$ 0,00"
                    value={valorUnitarioTipo3}
                    onValueChange={(values) => {
                      const { formattedValue, value } = values;
                      setValorUnitarioTipo3(formattedValue);
                      const valor = parseFloat(value) || 0;
                      const qtd = parseFloat(quantidadeTipo3) || 0;
                      const subTotal = valor * qtd;
                      setSubTotalItemTipo3(subTotal.toString());
                    }}
                    onBlur={(e) => {
                      validarValorUnitario(e.target.value);
                    }}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    prefix="R$ "
                    allowNegative={false}
                    autoComplete="off"
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="quantidade">Quantidade</label>
                  <input
                    type="number"
                    id="quantidade"
                    name="quantidade"
                    className="form-control"
                    value={quantidadeTipo3}
                    onChange={(e) => setQuantidadeTipo3(e.target.value)}
                    onBlur={(e) => {
                      validarQuantidade(e.target.value);
                      calcularSubTotalItemTipo3();
                    }}
                    min="1"
                    step="1"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <label htmlFor="subTotalItem">R$ Subtotal</label>
                  <NumberFormat
                    id="subTotalItem"
                    name="subTotalItem"
                    className="form-control"
                    value={subTotalItemTipo3}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    prefix="R$ "
                    readOnly
                    style={{ backgroundColor: '#f8f9fa' }}
                    autoComplete="off"
                  />
                </div>
                <div className="col-md-6 d-flex align-items-start">
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={addItemTipo3}
                    style={{ 
                      backgroundColor: '#014677', 
                      borderColor: '#014677',
                      marginTop: '32px',
                      height: '43px'
                    }}
                  >
                    <i className="fas fa-plus"></i> Adicionar Item
                  </button>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-12">
                  <ul className="lista" id="produtos">
                    {itensTipo3.map((item, index) => (
                      <li className="lista-item" key={index}>
                        {`${Number(item.qtde).toLocaleString('pt-BR')}x ${
                          item.nome
                        } - ${Number(item.valorUnitario).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })} - Subtotal: ${Number(item.subTotal).toLocaleString(
                          'pt-BR',
                          {
                            style: 'currency',
                            currency: 'BRL',
                          }
                        )}`}
                        <button onClick={delItemTipo3} className="btn-limpo">
                          <i id={index} className="fas fa-trash f-red"></i>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-md-6 offset-md-3">
                  <label htmlFor="total">R$ Total</label>
                  <NumberFormat
                    id="total"
                    name="total"
                    className="form-control"
                    value={totalTipo3}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    prefix="R$ "
                    readOnly
                    style={{ backgroundColor: '#f8f9fa' }}
                    autoComplete="off"
                  />
                </div>
              </div>
              <Row className="d-flex justify-content-center align-items-center">
                {!enviando ? (
                  <button disabled className="btn-enviar" type="submit">
                    ENVIANDO...
                  </button>
                ) : (
                  <button className="btn-enviar" type="submit">
                    ENVIAR
                  </button>
                )}
              </Row>
            </form>
          )}

          <div>
            <div>
              {erroInput.erroSaldo && (
                <div className="d-flex flex-column align-items-center">
                  <span
                    className="mb-2 align-self-center"
                    style={{ color: 'red' }}
                  >
                    Você não possui saldo para esse produto
                  </span>
                </div>
              )}
              {erroInput.erroDados && (
                <div className="d-flex flex-column align-items-center">
                  <span
                    className="mb-2 align-self-center"
                    style={{ color: 'red' }}
                  >
                    Preencha todos os dados e tente novamente
                  </span>
                </div>
              )}
              {erroInput.erroProdutoInvalido && (
                <div className="d-flex flex-column align-items-center">
                  <span
                    className="mb-2 align-self-center"
                    style={{ color: 'red' }}
                  >
                    Produto não participante
                  </span>
                </div>
              )}
              {parceiroRedux?.tipoPontuacaoRevenda === 1 && (
                <>
                  <ul className="text-center" style={{ listStyle: 'none' }}>
                    {itens &&
                      itens.map((item, index) => (
                        <li key={item.id}>
                          {item.codigo} - {item.nome} - R$
                          {item.valorUnitario
                            .toString()
                            .replace('.', ',')} -{' '}
                          {parseInt(item.valorPontos).toFixed(0)} pontos
                          <button onClick={delItem} className="btn-limpo ml-2">
                            <i id={index} className="fas fa-trash f-red"></i>
                          </button>
                        </li>
                      ))}
                  </ul>
                  <p className="mb-4 text-center">
                    Total:
                    {total !== 0 ? ` ${total} pontos` : ' 0'}
                  </p>
                  <form id="formDois" onSubmit={() => setEnviando(false)}>
                    <Row className="d-flex justify-content-center align-items-center">
                      <button className="btn-enviar" type="submit">
                        {!enviando ? 'Enviando...' : 'Enviar'}
                      </button>
                    </Row>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
        {cameraIsOpen && !isMobile && (
          <Scanner
            handleInsertCode={insertCode}
            handleCloseScanner={setCameraIsOpen}
          />
        )}
      </div>

      {/* Modal de confirmação de valor */}
      <ConfirmationModal
        isOpen={showModalValor}
        onClose={() => setShowModalValor(false)}
        onConfirm={confirmarModalValor}
        onCancel={cancelarModalValor}
        title="Confirmação"
        message={`Confirma o lançamento da pontuação no valor de ${formatCurrency(modalData.valor)}?`}
      />

      {/* Modal de confirmação de quantidade */}
      <ConfirmationModal
        isOpen={showModalQuantidade}
        onClose={() => setShowModalQuantidade(false)}
        onConfirm={confirmarModalQuantidade}
        onCancel={cancelarModalQuantidade}
        title="Confirmação"
        message={`Confirma o lançamento de ${modalData.quantidade} unidades do produto ${modalData.produto}?`}
      />
    </Container>
  );
}
